module.exports = __webpack_public_path__ + "img/FACEBOOK.b09cdd6f.svg";